"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createOutcomingOrderClient_1 = require("./createOutcomingOrderClient");
Object.defineProperty(exports, "createOutcomingOrderClient", { enumerable: true, get: function () { return createOutcomingOrderClient_1.default; } });
var deleteOutcomingOrderById_1 = require("./deleteOutcomingOrderById");
Object.defineProperty(exports, "deleteOutcomingOrderById", { enumerable: true, get: function () { return deleteOutcomingOrderById_1.default; } });
var deserializeOutcomingOrder_1 = require("./deserializeOutcomingOrder");
Object.defineProperty(exports, "deserializeOutcomingOrder", { enumerable: true, get: function () { return deserializeOutcomingOrder_1.default; } });
var getOutcomingOrderById_1 = require("./getOutcomingOrderById");
Object.defineProperty(exports, "getOutcomingOrderById", { enumerable: true, get: function () { return getOutcomingOrderById_1.default; } });
var getNextOutcomingOrderNumber_1 = require("./getNextOutcomingOrderNumber");
Object.defineProperty(exports, "getNextOutcomingOrderNumber", { enumerable: true, get: function () { return getNextOutcomingOrderNumber_1.default; } });
var postOutcomingOrder_1 = require("./postOutcomingOrder");
Object.defineProperty(exports, "postOutcomingOrder", { enumerable: true, get: function () { return postOutcomingOrder_1.default; } });
// export {
//   default as deleteOutcomingOrderCommentary
// } from "./deleteOutcomingOrderCommentary";
// export {
//   default as deserializeOutcomingOrderActivity
// } from "./deserializeOutcomingOrderActivity";
//
// export {
//   default as deserializeOutcomingOrderMatchQuery
// } from "./deserializeOutcomingOrderMatchQuery";
// export { default as getOutcomingOrderActivity } from "./getOutcomingOrderActivity";
// export { default as getOutcomingOrderDuplicate } from "./getOutcomingOrderDuplicate";
// export { default as postOutcomingOrderCommentary } from "./postOutcomingOrderCommentary";
// export { default as postOutcomingOrderPayment } from "./postOutcomingOrderPayment";
// export {
//   default as postOutcomingOrderBoardMatchQuery
// } from "./postOutcomingOrderBoardMatchQuery";
// export { default as putOutcomingOrderCommentary } from "./putOutcomingOrderCommentary";
// export {
//   default as postOutcomingOrderMatchQuery
// } from "./postOutcomingOrderMatchQuery";
// export {
//   default as postOutcomingOrderWaypointDriveThrough
// } from "./postOutcomingOrderWaypointDriveThrough";
// export {
//   default as deleteOutcomingOrderWaypointDriveThrough
// } from "./deleteOutcomingOrderWaypointDriveThrough";
// export {
//   default as putOutcomingOrderWaypointDriveThrough
// } from "./putOutcomingOrderWaypointDriveThrough";
// export { default as OutcomingOrderActivityData } from "./OutcomingOrderActivityData";
// export {
//   default as OutcomingOrderMatchQueryResultData
// } from "./OutcomingOrderMatchQueryResultData";
